module.exports = "/packs/images/social_society--desktop~a34780af407a8777ff0d8ea79bedfa0f.gif";